import { GreyBoxLoader, GreyCircleLoader, TextLoader } from '@xarvio/elements';
import styles from './CrossFarmDashboardHomeLoading.module.scss';
import { ColorCx, getBgColorCx, Text } from '@xarvio/corporate-styles';
import { Box, PageLayoutColumns, Row, RowCell } from '@xarvio/layout';
import React from 'react';
import loadingStyles from '../../../styles/loading.module.scss';
import cx from 'classnames';
import { CrossFarmDashboardFilterLoading } from './CrossFarmDashboardFilterLoading';
const WIDGET_LOADING_ITEM_COUNT = 6;

export const CrossFarmDashboardHomeLoading = () => {
  return (
    <PageLayoutColumns shiftForHeader>
      <div className={loadingStyles.panels}>
        <CrossFarmDashboardFilterLoading />
        <div
          className={cx(
            loadingStyles.panel,
            loadingStyles.panel_full,
            getBgColorCx(ColorCx.GREY_300),
          )}
        >
          <Box hpadding={'larger'} vpadding={'larger'} margin={false}>
            <Row align={'center'} gaps={'mediumNarrow'} margin={'large'}>
              <RowCell auto>
                <GreyCircleLoader size={32} />
              </RowCell>
              <RowCell auto>
                <Text type={'h3'}>
                  <TextLoader width={'12em'} />
                </Text>
              </RowCell>
            </Row>

            <div className={styles.grid}>
              {Array.from({ length: WIDGET_LOADING_ITEM_COUNT }, (_, index) => (
                <GreyBoxLoader key={index} style={{ height: 150 }} />
              ))}
            </div>
          </Box>
        </div>
      </div>
    </PageLayoutColumns>
  );
};
